import type { ColumnSubType, ReportColumn } from '../models/column.types'

export type NumericReportColumn = Pick<
  ReportColumn,
  'currency' | 'numeric' | 'percentage' | 'sub_type'
>

const NUMERIC_SUB_TYPES = new Set(['currency', 'decimal', 'meta', 'numeric', 'percentage'])

/** Keep every filter surface on the same backend column-kind interpretation. */
export function isNumericReportColumn(column: NumericReportColumn | null | undefined): boolean {
  return Boolean(
    column &&
    (column.numeric === true ||
      column.percentage === true ||
      column.currency === true ||
      (column.sub_type !== undefined && NUMERIC_SUB_TYPES.has(column.sub_type))),
  )
}

export function isPercentageReportColumn(column: NumericReportColumn | null | undefined): boolean {
  return column?.percentage === true || column?.sub_type === 'percentage'
}

/** Infer transport-relevant subtype flags that older catalog rows may express only as booleans. */
export function reportFilterSubTypeForColumn(
  column: NumericReportColumn | null | undefined,
): ColumnSubType | undefined {
  if (isPercentageReportColumn(column)) return 'percentage'
  if (column?.currency === true && column.sub_type === undefined) return 'currency'
  return column?.sub_type
}

/** Dropdown values belong to visible, non-media dimensions rather than numeric metrics. */
export function isReportFilterDropdownableColumn(column: ReportColumn): boolean {
  return (
    column.invisible !== true &&
    column.isImage !== true &&
    column.sub_type !== 'image' &&
    !isNumericReportColumn(column)
  )
}
